import { useRef, useState, useEffect } from 'react';
import { AgentForm } from '../../AgentForm';
import { noop } from '@navi/web-ui/lib/utils/common';
import { EditFormDrawerProps } from '../../interfaces/types';
import ViewAgentDrawer from './ViewAgentDrawer';
import EditAgentDrawer from './EditAgentDrawer';

const EditFormDrawer = (props: EditFormDrawerProps) => {
  const { onClose, isDrawerOpen, isEditable, setIsEditable, showLoader, setShowLoader } = props;

  const agentFormRef = useRef<any>(null);
  const [isOutsideClick, setIsOutsideClicked] = useState(false);
  const [isSubmitButtonDisabled, setIsSubmitButtonDisabled] = useState(false);
  const [isDirtyField, setIsDirtyField] = useState(false);
  const [isExitDisabledMode, setExitDisabledMode] = useState(false);
  const [showActionButton, setShowActionButton] = useState(false);

  const handleSubmitClick = () => {
    if (agentFormRef.current) {
      agentFormRef.current.submitForm();
    }
  };

  const toggleEditState = () => {
    setIsEditable(!isEditable);
  };

  const toggleOutsideClick = () => {
    if (isDirtyField) {
      setIsOutsideClicked(true);
      setExitDisabledMode(true);
    } else {
      setIsEditable(false);
      setIsOutsideClicked(false);
      onClose();
    }
  };

  const handleExitYesClick = () => {
    setIsEditable(false);
    setIsOutsideClicked(false);
    setExitDisabledMode(false);
    onClose();
  };

  const handleExitNoClick = () => {
    setIsOutsideClicked(false);
    setExitDisabledMode(false);
  };

  useEffect(() => {
    if (!isDrawerOpen) {
      setIsDirtyField(false);
    }
  }, [isDrawerOpen]);

  return isEditable ? (
    <EditAgentDrawer
      isDrawerOpen={isDrawerOpen}
      onClose={onClose}
      setShowLoader={setShowLoader}
      toggleOutsideClick={toggleOutsideClick}
      isDirtyField={isDirtyField}
      isOutsideClick={isOutsideClick}
      handleSubmitClick={handleSubmitClick}
      isSubmitButtonDisabled={isSubmitButtonDisabled}
      handleExitYesClick={handleExitYesClick}
      handleExitNoClick={handleExitNoClick}
      section={
        isDrawerOpen ? (
          <AgentForm
            ref={agentFormRef}
            onClose={onClose}
            isDrawerOpen={isDrawerOpen}
            isEditDisabled={isExitDisabledMode}
            setIsSubmitButtonDisabled={setIsSubmitButtonDisabled}
            setIsDirtyField={setIsDirtyField}
            showLoader={showLoader}
            setShowLoader={setShowLoader}
            isEditable={true}
            setShowActionButton={setShowActionButton}
          />
        ) : undefined
      }
      showActionButton={showActionButton}
    />
  ) : (
    <ViewAgentDrawer
      isDrawerOpen={isDrawerOpen}
      onClose={onClose}
      toggleEditState={toggleEditState}
      section={
        isDrawerOpen ? (
          <AgentForm
            isDrawerOpen={isDrawerOpen}
            onClose={onClose}
            isEditDisabled={true}
            showLoader={showLoader}
            setShowLoader={setShowLoader}
            setIsSubmitButtonDisabled={noop}
            isEditable={true}
            setShowActionButton={setShowActionButton}
          />
        ) : undefined
      }
      setShowLoader={setShowLoader}
    />
  );
};

export default EditFormDrawer;
